import { SetupIntentResult } from '@fox/finance';
import { useContentContext } from '../../../content-context';
import {
	useCompleteCardIntentMutation,
	useCompleteDebitIntentMutation,
	useSetupIntentMutation
} from '../../mutation-hooks/mutation-implementations';
import { PaymentProvider } from '../contracts';

export const useIntent = (
	provider: PaymentProvider,
	useLinkedOrganisationData: boolean
): {
	completeCard: (intentId: string, data: string) => Promise<number | undefined>;
	completeDebit: (intentId: string, data: string) => Promise<number | undefined>;
	setupIntent: () => Promise<SetupIntentResult | undefined>;
} => {
	const { contentId, requestToken } = useContentContext();
	const { mutate: setupIntentMutation } = useSetupIntentMutation({ requestToken });
	const { mutate: completeCardIntentMutation } = useCompleteCardIntentMutation({ requestToken });
	const { mutate: completeDebitIntentMutation } = useCompleteDebitIntentMutation({
		requestToken
	});

	const completeCard = async (intentId: string, data: string) => {
		const res = await completeCardIntentMutation({ contentId, data, id: intentId, useLinkedOrganisationData });

		return res;
	};
	const completeDebit = async (intentId: string, data: string) => {
		const res = await completeDebitIntentMutation({ contentId, data, id: intentId, useLinkedOrganisationData });

		return res;
	};
	const setupIntent = async () => {
		const res = await setupIntentMutation({
			contentId,
			method: provider.method,
			provider: provider.provider,
			useLinkedOrganisationData
		});

		return res;
	};

	return { completeDebit, completeCard, setupIntent };
};
